/** Read-only adapter for the existing tenant-scoped admin audit route. */
import { apiGet } from "../../lib/api.js";

export const GTCC_AUDIT_PATH = "/v1/admin/audit";
export const GTCC_AUDIT_KEY = ["gtcc", "audit", "entries"] as const;

export interface GtccAuditEntry {
  readonly id: string;
  readonly actorSub: string;
  readonly actorEmail: string;
  readonly action: string;
  readonly targetType: string;
  readonly targetId: string;
  readonly createdAt: string;
}

export interface GtccAuditPage {
  readonly items: readonly GtccAuditEntry[];
  readonly nextCursor: string | null;
}

export interface GtccAuditFilters {
  readonly actorSub?: string;
  readonly action?: string;
  readonly since?: string;
  readonly until?: string;
  readonly cursor?: string;
}

/** The API already enforces tenant isolation and `tenant.read`; this client only reads it. */
export function fetchGtccAudit(
  filters: GtccAuditFilters = {},
  signal?: AbortSignal,
): Promise<GtccAuditPage> {
  // The existing route deliberately exposes snake_case query parameters. Keep
  // that transport detail here so the view deals only in its typed model.
  const { actorSub, ...rest } = filters;
  return apiGet<GtccAuditPage>(
    GTCC_AUDIT_PATH,
    { limit: 25, ...rest, ...(actorSub === undefined ? {} : { actor_sub: actorSub }) },
    signal,
  );
}
